import React, { useContext, useEffect, useRef, useState } from 'react';
import { AuthContext } from 'context/auth';
// @ts-ignore
import { Box, Button, FormControl, FormLabel, Heading, Input, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Textarea, Divider, useToast, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Tag, Center, Spinner, HStack, IconButton, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, useDisclosure } from '@chakra-ui/react';
// @ts-ignore
import { config, mfrProcessSelectables, subSystemSelectables, materialSelectables, finishSelectables, prioritySelectables } from 'util/constants';
import { CreatableSelect, Select } from "chakra-react-select";
import { MCFFormsContext } from 'context/mcfforms';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { BsTrash } from 'react-icons/bs';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';

// @ts-ignore
export default function UpdateApprovedSubmissionForm(props) {
    const { user } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    // @ts-ignore
    const { MCFForms, getMCFForms } = useContext(MCFFormsContext);
    const { objectId: objectIdParam } = useParams();
    const [authorizedUser, setAuthorizedUser] = useState(false);
    const [form, setForm] = useState(null);
    const timeLoaded = useRef(null);
    const navigate = useNavigate();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = useRef();

    const handleDelete = (e) => {
        e.target.disabled = true;
        fetch(`/transactions/deleteMCFForm/${objectIdParam}`, {
            method: 'GET',
        }).then(response => {
            if (response.status !== 200) {
                throw `${response.status}: ${response.statusText}`
            }
            return response.text();
        // @ts-ignore
        }).then(function(data) {
            // Success
            getMCFForms(() => {
                setTimeout(() => {
                    toast({
                        title: 'Part MCF Submission Deleted',
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                    });
                    e.target.disabled = false;
                    setLoading(false);
                    navigate('/');
                }, 500);
            });
        })
        .catch(err => {
            e.target.disabled = false;
            setLoading(false);
            console.log(err);
            errorToast();
        });
    }

    const errorToast = () => {
        toast({
            title: 'Error',
            description: 'There was an error processing your request',
            status: 'error',
            duration: 5000,
            isClosable: true,
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let changes = [];
        let formData = {};
        formData.quantity = e.target.quantity.value;
        formData.priority = e.target.priority.value;
        formData.notes = form.notes;
        if (e.target.notes.value)
        {
            formData.notes.push({ 
                timestamp: Date.now(),
                note: `${user.firstName} ${user.lastName.charAt(0)}: ${e.target.notes.value}`
            });
        }

        formData.googleId =  user.googleId;
        formData.firstName = user.firstName;
        formData.lastName = user.lastName;

        if (formData.quantity !== form.quantity.toString()) {
            changes.push("Quantity");
            form.quantity = formData.quantity;
        }
        if (formData.priority !== form.priority.toString()) {
            changes.push("Priority");
            form.quantity = formData.priority;
        }

        setLoading(true);
        if (changes.length > 0 || e.target.notes.value)
        {
            fetch(`/transactions/getMCFForm/${objectIdParam}`, {
                method: 'GET',
            }).then(response => {
                if (response.status !== 200) {
                    throw `${response.status}: ${response.statusText}`
                }
                return response.json();
            }
            ).then(data => {
                if (new Date(timeLoaded.current).getTime() > new Date(data.docs.updatedAt).getTime())
                {
                    if (changes.length > 0)
                    {
                        formData.notes.push({ 
                            timestamp: Date.now(),
                            note: `Changes made to ${changes.join(', ')} by ${user.firstName} ${user.lastName.charAt(0)}.`
                        });
                    }
                    fetch(`/transactions/updateMCFForm/${objectIdParam}`, {
                        method: 'POST',
                        // We convert the React state to JSON and send it as the POST body
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData)
                    }).then(response => {
                        if (response.status !== 200) {
                            throw `${response.status}: ${response.statusText}`
                        }
                        return response.text();
                    // @ts-ignore
                    }).then(function(data) {
                        // Success
                        e.target.reset();
                        getMCFForms(() => {
                            setTimeout(() => {
                                toast({
                                    title: 'Part MCF Updated',
                                    status: 'success',
                                    duration: 5000,
                                    isClosable: true,
                                });
                                setLoading(false);
                                navigate('/');
                            }, 500);
                        });
                    })
                    .catch(err => {
                        setLoading(false);
                        console.log(err);
                        errorToast();
                    });
                    
                } else {
                    toast({
                        title: 'Error',
                        description: 'Current document is outdated. Please refresh.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                    });
                    setLoading(false);
                }
            }).catch(err => {
                setLoading(false);
                errorToast();
                console.error(err);
            });
        } else {
            setTimeout(() => {
                toast({
                    title: 'Part MCF Updated',
                    status: 'success',
                    duration: 5000,
                    isClosable: true,
                });
                setLoading(false);
                navigate('/');
            }, 500);
        }
    }
    
    const handlePriority = (priority) => {
        switch(priority)
        {
            case 1: return 'National Emergency'
            case 2: return 'High'
            case 3: return 'Medium'
            case 4: return 'Low'
            default: 'Undefined'
        }
    }

    useEffect(() => {
        try
        {
            fetch(`/transactions/getMCFForm/${objectIdParam}`, {
                method: 'GET',
            }).then(response => {
                if (response.status !== 200) {
                    throw `${response.status}: ${response.statusText}`
                }
                return response.json();
            }
            ).then(data => {
                data.docs.mfrProcessDefault = data.docs.mfrProcess.map(e => {
                    return { label: e, value: e }
                });

                setTimeout(() => setForm(data.docs), 250);
                if (data.docs.approved && !data.docs.manufactured && (data.docs.googleId === user.googleId || user.admin))
                {
                    setAuthorizedUser(true);
                }
                timeLoaded.current = data.timestamp;
            }).catch(err => {
                console.error(err);
            });

        } catch (e)
        {
            console.log(e);
        }
    }, []);

    if (!form)
    {
        return (<>
        <Box margin={'0 auto'} mt={"1em"} width={{ base: '85%', md: '66%', lg: '50%' }}>
            <Tag backgroundColor={'white'}>
                <Breadcrumb separator={<ChevronRightIcon color='gray.500' />}>
                    <BreadcrumbItem>
                        <BreadcrumbLink as={RouterLink} to={`/`}>Home</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                        <BreadcrumbLink>Edit Form</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Tag>
            <Center><Spinner mt={'2em'} size='lg' /></Center>
        </Box></>)
    }

    return (
        <>
            <Box margin={'0 auto'} mt={"1em"} width={{ base: '85%', md: '66%', lg: '50%' }}>
                <Tag backgroundColor={'white'}>
                    <Breadcrumb separator={<ChevronRightIcon color='gray.500' />}>
                        <BreadcrumbItem>
                            <BreadcrumbLink as={RouterLink} to={`/`}>Home</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <BreadcrumbLink>Edit Form</BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Tag>
            </Box>
            <Box margin={'1em auto'} width={{ base: '85%', md: '66%', lg: '50%' }}
                p={4}
                borderWidth="1px"
                rounded="lg"
                shadow="1px 1px 3px rgba(0,0,0,0.3)"
                bgColor={'#fff'}>
                {authorizedUser ? (<>
                <Heading mb={2} as="h1" size="lg" textAlign="center">
                    Edit Part MCF Form
                </Heading>
                <Divider />
                <form onSubmit={handleSubmit} autoComplete="off">
                <FormControl isRequired mt={2}>
                        <FormLabel>Subsystem</FormLabel>
                        <Select isReadOnly variant='filled'required name="subsystem" size="sm"
                        defaultValue={{label: form.subsystem, value: form.subsystem}}
                        options={subSystemSelectables}/>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>File Path</FormLabel>
                        <Input isReadOnly onFocus={e => e.target.blur() } variant='filled' name="filePath" type="text" size="sm" defaultValue={form.filePath}/>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>File Name</FormLabel>
                        <Input isReadOnly onFocus={e => e.target.blur() } variant='filled' name="fileName" type="text" size="sm" defaultValue={form.fileName}/>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>Revision</FormLabel>
                        <Input isReadOnly onFocus={e => e.target.blur() } variant='filled' name="revision" type="text" size="sm" defaultValue={form.revision}/>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>Quantity</FormLabel>
                        <NumberInput name="quantity" defaultValue={form.quantity} min={1} max={9001}>
                        <NumberInputField />
                        <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                        </NumberInputStepper>
                        </NumberInput>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>Material</FormLabel>
                        <CreatableSelect isReadOnly variant='filled' required name="material" placeholder="Select Material..." size="sm"
                        defaultValue={{ label: form.material, value: form.material }}
                        options={materialSelectables}/>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>Machine(s)</FormLabel>
                        <Select isReadOnly variant='filled' required isMulti name="mfrprocess"  size="sm"
                        value={form.mfrProcessDefault}
                        options={mfrProcessSelectables}/>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>Finish</FormLabel>
                        <CreatableSelect isReadOnly variant='filled' required name="finish" placeholder="Select Finish..." size="sm"
                        defaultValue={{ label: form.finish, value: form.finish }}
                        options={finishSelectables}/>
                    </FormControl>
                    <FormControl isRequired mt={2}>
                        <FormLabel>Priority</FormLabel>
                        <Select required name="priority"  size="sm"
                        defaultValue={{label: handlePriority(form.priority), value: form.priority}}
                        options={prioritySelectables}/>
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Add Note</FormLabel>
                        <Textarea name="notes"
                            placeholder='Notes'
                            size='md'
                        />
                    </FormControl>
                    <HStack mt={4}>
                        <Button
                            isLoading={loading}
                            name="submitButton"
                            loadingText='Submitting'
                            colorScheme="teal"
                            type="submit"
                            width="full"
                        >
                            Submit
                        </Button>
                        <IconButton
                            colorScheme='blue'
                            aria-label='Delete'
                            icon={<BsTrash />}
                            onClick={onOpen}
                        />
                    </HStack>
                </form>
                <AlertDialog
                    isOpen={isOpen}
                    leastDestructiveRef={cancelRef}
                    onClose={onClose}
                >
                    <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {form.fileName}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            Are you sure? You can't undo this action afterwards.
                        </AlertDialogBody>

                        <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button colorScheme='red' onClick={handleDelete} ml={3}>
                            Delete
                        </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
                </>
                ) : (<><Center>Not Authorizied</Center></>)}
            </Box>
        </>
    );
}
